// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const rolePolicyAnalyticsDashboardViewer = {
  id: "policy-analytics-dashboard-viewer",
  mrn: "//iam.api.mondoo.app/roles/policy-analytics-dashboard-viewer",
  title: "Policy Analytics Dashboard Viewer",
  allowedActions,
} as const;

export type RolePolicyAnalyticsDashboardViewer =
  typeof rolePolicyAnalyticsDashboardViewer;
